// extracted by mini-css-extract-plugin
export default {"footer_buttons":"styles_footer_buttons__bXgk7","buttons":"styles_buttons__9rjht"};